import { IRumbleFormScope } from ".";
import { useStateMachine } from "little-state-machine";
import { IFormStep } from "@formily/antd-v5";
import { theme } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import { hexToRgb } from "../../helpers/color";
const { useToken } = theme;

interface RumbleWelcomeStepRowProps {
  title: string;
  description?: string;
}

export const RumbleWelcomeStepRow = ({
  title,
  description,
}: RumbleWelcomeStepRowProps) => {
  const { state } = useStateMachine();
  const scope = (state as { scope?: IRumbleFormScope }).scope;
  const formStep = scope?.formStep as IFormStep;
  if (!formStep) {
    throw new Error("formStep function is not available");
  }
  const { token } = useToken();

  return (
    <button
      aria-label={title}
      type="button"
      onClick={() => formStep.next()}
      className={`w-full flex items-center rounded-xl px-2 pt-12 pb-8 text-center mt-8 flex-col relative md:pt-8 md:text-left md:mt-4 md:flex-row`}
      style={{
        backgroundColor: `rgba(${hexToRgb(token.colorPrimary)}, 0.1)`,
      }}
    >
      <span className="w-[120px] flex justify-center text-2xl md:relative md:top-auto absolute -top-5">
        <span className="bg-white rounded-full w-10 h-10 flex items-center justify-center border-black border-solid border-[3px]">
          <CheckOutlined
            style={{
              color: token.colorPrimary,
            }}
          />
        </span>
      </span>

      <div>
        <h3
          className="text-xl font-extrabold leading-4"
          style={{
            color: token.colorPrimary,
          }}
        >
          {title}
        </h3>
        {description ? (
          <p className="text-sm text-black mt-3 font-medium">{description}</p>
        ) : null}
      </div>
    </button>
  );
};
